import request from './request';
export const Authorize = '/Ceiba.PlaySrv/ActivityAuthorize';
export const GetActivityAuthorize = '/Ceiba.PlaySrv/GetActivityAuthorize';
export const GetInviteCode = '/Ceiba.PlaySrv/GetInviteCode';
export const GetInviteInfo = '/Ceiba.PlaySrv/GetInviteInfo';
export const GetCommandCode = '/Ceiba.PlaySrv/GetCommandCode';
export const GetCommandInfo = '/Ceiba.PlaySrv/GetCommandInfo';
export const GetActivityRoleInfo = '/Ceiba.PlaySrv/GetActivityRoleInfo';
// 新版本获取邀请码
export const GetInviteCodeNewVersion = '/action/api/common/generateInvitationCode';
// 新版本获取邀请信息
export const GetInviteInfoNewVersion = '/action/api/common/getInvitationInfo';
// 新版本活动邀请列表
export const GetUserInviteListNewVersion = '/action/api/common/invitationList';
export default class User {
  static activityAuthorize(params) {
    return request.post(Authorize, { ...params });
  }

  static async getActivityAuthorize(params) {
    try {
      const data = await request.post(GetActivityAuthorize, { ...params });
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getInviteCode(params) {
    try {
      const data = await request.post(GetInviteCode, { ...params });
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getInviteInfo(params) {
    try {
      const data = await request.post(GetInviteInfo, { ...params });
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async getCommandCode(params) {
    try {
      const data = await request.post(GetCommandCode, { ...params });
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getCommandInfo(params) {
    try {
      const data = await request.post(GetCommandInfo, { ...params });
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async getActivityRoleInfo(params) {
    try {
      const data = await request.post(GetActivityRoleInfo, { ...params });
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async getInviteCodeNewVersion(params) {
    try {
      const data = await request.post(GetInviteCodeNewVersion, { ...params });
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getInviteInfoNewVersion(params) {
    try {
      const data = await request.post(GetInviteInfoNewVersion, { ...params });
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async getUserInviteListNewVersion(params) {
    try {
      const data = await request.post(GetUserInviteListNewVersion, { ...params });
      return data;
    } catch (error) {
      throw error;
    }
  }
}
